import React from 'react';

function LiveBetsHeader({ setSelectedColumn, selectedColumn, t, liveBetsColumnHeader }) {
  return (
    <div className='cpt-info-tabs-row'>
      <div className='cpt-info-tabs'>
        {liveBetsColumnHeader.map(({ id, title }) => {
          return (
            <div
              key={id}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedColumn(id);
              }}
              className={`cpt-info-tab ${id === selectedColumn ? 'active' : ''}`}
            >
              {/* <i className='cpt-info-tab-icon icon-insurance' /> */}
              <span className='cpt-info-tab-text'>{t(title)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export default LiveBetsHeader;
